import { render, staticRenderFns } from "./DeviceMonitoringCard.vue?vue&type=template&id=0516cfa0&scoped=true"
import script from "./DeviceMonitoringCard.vue?vue&type=script&lang=ts"
export * from "./DeviceMonitoringCard.vue?vue&type=script&lang=ts"
import style0 from "./DeviceMonitoringCard.vue?vue&type=style&index=0&id=0516cfa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0516cfa0",
  null
  
)

export default component.exports